import React from "react";
import PropTypes from "prop-types";
import * as TypeComponents from "../Type";

const Heading = ({ level, children, ...rest }) => {
  const $component = TypeComponents[`H${level}`];
  // eslint-disable-next-line react/jsx-pascal-case
  return <$component {...rest}>{children}</$component>;
};

Heading.propTypes = {
  level: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired
};

export default Heading;
